<template>
<!--  <iframe v-if="list.length === 1 && list[0].url" style="width: 100%; height: 600px;border: none;" :src="list[0].url" />-->
  <div class="content-wrap support-wrap">
    <!--    <van-nav-bar class="header bg-template" fixed z-index="999" left-arrow @click-left="$router.back()" style="backdrop-filter: none;">-->
    <!--      <template #right>-->
    <!--        <zlink to="/m/user/message"><i class="material-icons text-white">notifications_none</i></zlink>-->
    <!--      </template>-->
    <!--    </van-nav-bar>-->
    <!--    <m-header class="mb-2" title="" is-none-bg :is-left="false" />-->

    <div class="container justify-center bg-template bg-blue mb-4 pb-60">
      <div class="row">
        <div class="col text-center">
          <!--          <h5 class="subtitle mb-1">{{ $t('专属客户服务') }}</h5>-->
          <div v-if="paramMapAll['SERVICE_ONLINE_TIPS']" class="u-font-20 u-m-t-20 text-ffff00 font-bold">{{ $t(paramMapAll['SERVICE_ONLINE_TIPS']) }}</div>
        </div>
      </div>
    </div>

    <div class="container justify-center">
      <div v-for="(item,index) in list" :key="index" class="row justify-center">
        <div class="col-12 col-md-6">
          <div class="card shadow border-0 mb-2">
            <a :href="item.url" target="_blank">
              <div class="card-body d-flex flex-column justify-center align-center text-center">
                <div class="avatar avatar-60 no-shadow border-0">
                  <!--                  <div class="overlay bg-template" />-->
                  <img :src="`/static/customer/${item.type || 'kf'}.png`" width="50">
                </div>
                <!--                <iframe src="https://line.me/R/ti/p/ysmToFwoRG"></iframe>-->
                <!--                <zqrcode class="pa-2" :text="item.url"></zqrcode>-->
                <p class="mt-2 mb-0 font-weight-normal text-dark"><span style="position: relative;top:1px">{{ item.username }}</span></p>
                <p v-if="item.number" class="mt-2 mb-0 font-weight-normal text-dark"><span style="position: relative;top:1px">{{ item.number }}</span></p>
                <p class="mt-2 mb-0 font-weight-normal text-dark"><span style="position: relative;top:1px">{{ item.beginTime }} - {{ item.endTime }}</span></p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getCustomerList, getUserCustomerList } from '@/api/user'
import Zqrcode from '@/components/z/zqrcode.vue'
export default {
  name: 'MSupport',
  components: { Zqrcode },
  data() {
    return {
      list: []
    }
  },
  computed: {
    // ...Vuex.mapGetters([
    //   'paramMapAll',
    //   'userInfo'
    // ])
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      getCustomerList().then(res => {
        this.list = res.data
      })
      // if (this.account.id) {
      //   getUserCustomerList().then(res => {
      //     this.list = res.data
      //   })
      // } else {
      //
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    .van-nav-bar .van-icon {
      color: #fff;
    }
    .van-hairline--bottom::after {
      border: none;
    }
  }
</style>
